import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as $ from "jquery/dist/jquery";
import * as M from "materialize-css/dist/js/materialize";

import { ResourcesService } from '../resources.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-galpones',
    templateUrl: './galpones.component.html',
    styleUrls: ['./galpones.component.css']
})
export class GalponesComponent implements OnInit, OnDestroy {

    galpones: any = [];
    title: string = 'Galpones';
    instance: any;
    user: any = {}
    subscriptions: Subscription
    constructor(
        private http: HttpClient,
        private router: Router,
        public resource: ResourcesService
    ) {

        let user = localStorage.getItem('user')
        this.user = JSON.parse(user);
        this.resource.galponesState = false;
        this.resource.lotesState = false;
        this.resource.corralesState = false;
        this.resource.semanasState = false;
        this.resource.nacimientosState = false;
        this.resource.stdGranjaState = false;
        this.resource.stdPlantaState = false;


    }
    ngOnDestroy(): void {
        this.subscriptions?.unsubscribe()
    }

    async ngOnInit(): Promise<void> {
        try {
            if (this.user == undefined) {
                this.router.navigate(['/']);
                return
            } else {
                const data: any = await this.http.get(this.resource.route + '/galpones').toPromise()
                await this.confirm();
                for (let i = 0; i < data.length; i++) {
                    data[i]['fecha_creacion'] = '2020-01-12T23:00:00.000Z'
                }
                this.galpones = data.reverse();

                await this.resource.updateLocalStorageFromOnline()
                this.resource.semanasState = true;
                this.resource.nacimientosState = true;
                this.instance.close()
               
            }
        } catch (error) {
            let galpones = localStorage.getItem('galpones')
            this.galpones = JSON.parse(galpones).reverse();
        }

    }

    goToLote(idGalpon) {
        this.router.navigateByUrl('/lotes/' + idGalpon);
    }

    confirm() {
        const elem = document.getElementById('modalSincronizacionServidorLocal');
        this.instance = M.Modal.init(elem);
        this.instance.open();
    }

    close() {
        this.instance.close();
    }

}
